import React, { useState } from 'react';

// "Tips from Jody": the short notes the AI writes with a journey (night
// trains spec §6.3, "notes are shown to the user"). Sits between the summary
// pills and the route. Three states, so it takes little room (Paulo
// 2026-09-30): closed at first, one line with the count; opened, the first
// two tips and "Show all N tips"; then every tip. The heading toggles the
// section open and closed at any point. Hidden when the journey has none.
// The text is shown as is: first the rule-based tips Jody derives from the
// journey itself (backend/services/journeyTips.js, e.g. a Nightjet on
// board; night trains README, "Rule-based tips"), then the AI's own. API
// field: journey.tips (backend/services/journeyTransform.js). Same header
// convention as SectionToggle (aria-expanded, chevron rotating 180deg).

const SHOWN = 2;

const JourneyTips: React.FC<{ tips?: string[] | null }> = ({ tips }) => {
  const [open, setOpen] = useState(false);
  const [all, setAll] = useState(false);
  const list = (tips || []).filter((t) => typeof t === 'string' && t.trim());
  if (list.length === 0) return null;
  const visible = all ? list : list.slice(0, SHOWN);

  return (
    <section aria-label="Tips from Jody" style={{ background: '#fff', border: '1px solid rgba(20,40,30,0.10)', borderRadius: 14, padding: '10px 14px' }}>
      {/* Both buttons carry data-share-ok: opening tips edits nothing, so the
          read-only shared page lets them through (pages/SharedJourneyPage.tsx). */}
      <button
        type="button"
        data-share-ok
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, width: '100%', background: 'none', border: 'none', padding: 0, font: 'inherit', cursor: 'pointer', textAlign: 'left' }}
      >
        <span style={{ fontFamily: 'Fraunces, Georgia, serif', fontWeight: 600, fontSize: 15, color: '#16241d' }}>
          <span aria-hidden>💡 </span>Tips from Jody
          {!open && <span style={{ fontFamily: 'inherit', fontWeight: 500, fontSize: 12.5, color: '#6c7872' }}> · {list.length}</span>}
        </span>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden style={{ flex: 'none', color: '#6c7872', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .18s' }}>
          <path d="M3 6l5 5 5-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
      {open && (
        <>
          <ul style={{ listStyle: 'none', margin: '9px 0 0', padding: 0, display: 'grid', gap: 7 }}>
            {visible.map((tip, i) => (
              <li key={i} style={{ display: 'flex', gap: 8, fontSize: 13.5, lineHeight: 1.4, color: '#16241d' }}>
                <span aria-hidden style={{ color: '#157a55', fontWeight: 800, flex: 'none' }}>•</span>
                <span>{tip}</span>
              </li>
            ))}
          </ul>
          {list.length > SHOWN && (
            <button
              type="button"
              data-share-ok
              onClick={() => setAll((a) => !a)}
              aria-expanded={all}
              style={{ marginTop: 9, background: 'none', border: 'none', padding: 0, font: 'inherit', fontSize: 12.5, fontWeight: 700, color: '#157a55', cursor: 'pointer' }}
            >
              {all ? 'Show fewer' : `Show all ${list.length} tips`}
            </button>
          )}
        </>
      )}
    </section>
  );
};

export default JourneyTips;
